import { createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "PageFooter"
};
const _hoisted_2 = {
  class: "content"
};
const _hoisted_3 = {
  class: "content_top"
};
const _hoisted_4 = {
  class: "top_item"
};
const _hoisted_5 = {
  class: "top_item"
};
const _hoisted_6 = {
  class: "top_item"
};
const _hoisted_7 = {
  class: "top_right"
};
const _hoisted_8 = {
  class: "wx"
};
const _hoisted_9 = {
  alt: ""
};
const _hoisted_10 = {
  class: "wx"
};
const _hoisted_11 = {
  alt: ""
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Normal = _resolveComponent("Normal");
  const _component_Batch = _resolveComponent("Batch");
  const _directive_lazy = _resolveDirective("lazy");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_cache[8] || (_cache[8] = _createElementVNode("div", null, "产品", -1)), _createElementVNode("div", {
    onClick: _cache[0] || (_cache[0] = $event => $options.openPopup('normal'))
  }, "爱开单通用版"), _createElementVNode("div", {
    onClick: _cache[1] || (_cache[1] = $event => $options.openPopup('batch'))
  }, "爱开单批发版"), _createElementVNode("div", {
    onClick: _cache[2] || (_cache[2] = $event => $options.openPopup('delivery'))
  }, "爱开单配送版")]), _createElementVNode("div", _hoisted_5, [_cache[9] || (_cache[9] = _createElementVNode("div", null, "解决方案", -1)), _createElementVNode("div", {
    onClick: _cache[3] || (_cache[3] = $event => $options.navTo('normal'))
  }, "通用场景"), _createElementVNode("div", {
    onClick: _cache[4] || (_cache[4] = $event => $options.navTo('batch'))
  }, "档口批发"), _createElementVNode("div", {
    onClick: _cache[5] || (_cache[5] = $event => $options.navTo('delivery'))
  }, "分拣配送")]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", {
    onClick: _cache[6] || (_cache[6] = $event => $options.navTo('aboutUs'))
  }, "关于我们"), _createElementVNode("div", {
    onClick: _cache[7] || (_cache[7] = $event => $options.navTo('free'))
  }, "免费使用")]), _createElementVNode("div", _hoisted_7, [_cache[12] || (_cache[12] = _createElementVNode("div", null, "CONTACT US", -1)), _cache[13] || (_cache[13] = _createElementVNode("div", null, "联系我们", -1)), _cache[14] || (_cache[14] = _createElementVNode("div", {
    class: "line"
  }, null, -1)), _cache[15] || (_cache[15] = _createElementVNode("div", null, "400-6778-983", -1)), _cache[16] || (_cache[16] = _createElementVNode("div", null, "周一至周五 9:00 - 21:00", -1)), _cache[17] || (_cache[17] = _createElementVNode("div", null, "地址：广州市番禺区巨大创意产业园15栋A102室", -1)), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_8, [_withDirectives(_createElementVNode("img", _hoisted_9, null, 512), [[_directive_lazy, $data.qywxImg]]), _cache[10] || (_cache[10] = _createElementVNode("div", null, "微信客服", -1))]), _createElementVNode("div", _hoisted_10, [_withDirectives(_createElementVNode("img", _hoisted_11, null, 512), [[_directive_lazy, $data.gzhImg]]), _cache[11] || (_cache[11] = _createElementVNode("div", null, "微信公众号", -1))])])])]), _cache[18] || (_cache[18] = _createElementVNode("div", {
    class: "middle_line"
  }, null, -1)), _cache[19] || (_cache[19] = _createElementVNode("div", {
    class: "bottom"
  }, [_createElementVNode("div", null, "©2022 广州禾一科技有限公司 版权所有"), _createElementVNode("div", null, "粤ICP备19160406号-1")], -1))])]), _createVNode(_component_Normal, {
    show: $data.showNormal,
    ref: "normal"
  }, null, 8, ["show"]), _createVNode(_component_Batch, {
    show: $data.showBatch,
    ref: "batch"
  }, null, 8, ["show"])], 64);
}